import script from "./Klodstabel.vue?vue&type=script&setup=true&lang=ts"
export * from "./Klodstabel.vue?vue&type=script&setup=true&lang=ts"

export default script